import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLockIconLocked = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.99935 9.66667V11M4.66602 6.68586C4.9803 6.66667 5.36774 6.66667 5.86602 6.66667H10.1327C10.631 6.66667 11.0184 6.66667 11.3327 6.68586M4.66602 6.68586C4.2738 6.7098 3.99554 6.76364 3.75803 6.88465C3.38171 7.0764 3.07575 7.38236 2.884 7.75869C2.66602 8.18651 2.66602 8.74656 2.66602 9.86667V10.8C2.66602 11.9201 2.66602 12.4802 2.884 12.908C3.07575 13.2843 3.38171 13.5903 3.75803 13.782C4.18586 14 4.74591 14 5.86602 14H10.1327C11.2528 14 11.8128 14 12.2407 13.782C12.617 13.5903 12.9229 13.2843 13.1147 12.908C13.3327 12.4802 13.3327 11.9201 13.3327 10.8V9.86667C13.3327 8.74656 13.3327 8.18651 13.1147 7.75869C12.9229 7.38236 12.617 7.0764 12.2407 6.88465C12.0032 6.76364 11.7249 6.7098 11.3327 6.68586M4.66602 6.68586V5.33333C4.66602 3.49238 6.1584 2 7.99935 2C9.8403 2 11.3327 3.49238 11.3327 5.33333V6.68586",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgLockIconLocked;
